import React, { Component } from "react";
import { App } from "../../App";
import { AppScreen } from "../../AppScreen";
import landingFooterImage from "../../assets/images/landing-footer.png";
import landingSun from "../../assets/images/sun.png";
import landingLogo from "../../assets/images/landing-logo.png";
import copyrightText from "../../assets/images/copyright.png";
import { PlaneAnimation } from "../components/animations/PlaneAnimation";
import { SunAnimation } from "../components/animations/SunAnimation";
import { BeeAnimation } from "../components/animations/BeeAnimation";


export interface LandingScreenProps
{
}

interface LandingScreenState 
{
}

export class LandingScreen extends Component<LandingScreenProps, LandingScreenState>
{
    constructor(props: LandingScreenProps)
    {
        super(props);

        this.state = {
        };
    }

    public render(): JSX.Element
    {
        return (
            <>
                <div className="landing-screen">
                    <div className="sun">
                        {/* <SunAnimation /> */}
                    </div>

                    <div className="landing-container">
                        <div className="container">
                            <div className="landing-logo">
                                <img src={landingLogo} alt="Fun & Games with Mr.Adventure & Little Miss Explorer!" />
                            </div>
                            <div className="d-flex mt-auto mb-0 btn-container">
                                <button className="btn btn-primary btn-lg w-47" onClick={() => App.I.changeScreen(AppScreen.GamesActivities)} title="Games and Activities">
                                    Games and Activities
                                </button>
                                <button className="btn btn-primary btn-lg w-47" onClick={() => App.I.changeScreen(AppScreen.MeetTheCharacters)} title="Meet the Characters">
                                    Meet the Characters
                                </button>
                            </div>

                            <div className="d-flex ms-auto me-auto mt-2 parent-zone-container">
                                <button className="btn btn-primary parent-zone-btn" onClick={() => App.I.changeScreen(AppScreen.ParentZone)}>
                                    Parent Zone
                                </button>
                            </div>

                            <div className="d-flex pt-3 pb-3 sponsors">
                                <img src={landingFooterImage} alt="Mr.Men Little Miss, Exclusively to Heathrow" />
                            </div>

                            <div className="d-flex footer">
                                <div className="copyright-text text-center m-auto">
                                    <img src={copyrightText} alt="Mr.Men &trade; Little Miss &trade;  &copy; 2023 THOIP (a SANRIO Company). ALl rights reserved." />
                                </div>
                            </div>
                        </div>

                        <div className="animation-plane">
                            <PlaneAnimation />
                        </div>

                        {/* <div className="animation-bee">
                            <BeeAnimation />
                        </div> */}
                    </div>
                </div>
            </>
        );
    }
}